import React, { Component } from 'react';
import { HeroSection } from './components/HeroSection';
import { QuickAsk } from './components/QuickAsk';
import { IntegrationComparison } from './components/IntegrationComparison';
import { BeforeAfterComparison } from './components/BeforeAfterComparison';
import { Timeline } from './components/Timeline';
import { WaitlistForm } from './components/WaitlistForm';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { ProblemSection } from './components/ProblemSection';
import { CheckIcon } from 'lucide-react';
import { AIFeaturesSection } from './components/AIFeaturesSection';
import { ReversedFeaturesSection } from './components/ReversedFeaturesSection';
import { BackgroundGradients } from './components/BackgroundGradients';
const includedFeatures = ['Forever pricing guarantee', 'AI pattern recognition', 'Priority access to new features', 'Multi-channel audit automation'];
export function App() {
  return <div className="w-full min-h-screen bg-white relative" data-id="element-0">
      {/* Global background gradients */}
      <BackgroundGradients data-id="element-1" />
      <HeroSection data-id="element-2" />
      {/* First AI Features Section - Title on left, features on right */}
      <AIFeaturesSection title="Race Ahead with AI-Powered Analytics" subtitle="Unlock the full potential of your e-commerce data with our Formula 1-inspired approach to business intelligence." accentColor="text-benetton-green" backgroundColor="bg-white" borderColor="border-benetton-green" features={[{
      title: 'Hours Wasted',
      description: 'Manually exporting data from multiple platforms to combine in spreadsheets'
    }, {
      title: 'Technical Skills Required',
      description: 'Need SQL knowledge or data analysts to create custom reports'
    }, {
      title: 'Data Silos',
      description: 'Information trapped in different systems with no unified view'
    }, {
      title: 'Limited Insights',
      description: 'Only see what existing dashboards are configured to show'
    }]} data-id="element-3" />
      {/* Reversed Features Section - Currently not implemented */}
      <ReversedFeaturesSection title="Meet Naiomi.ai Your AI eCommerce Analyst" subtitle="Unlock the full potential of your e-commerce data with our Formula 1-inspired approach to business intelligence." accentColor="text-benetton-green" backgroundColor="bg-white" borderColor="border-benetton-green" className="pt-24" data-id="element-4" />
      {/* Third ReversedFeaturesSection has been removed as requested */}
      <ProblemSection data-id="element-5" />
      <IntegrationComparison data-id="element-6" />
      {/* Pricing Section removed as requested */}
      <BeforeAfterComparison data-id="element-7" />
      <CallToAction data-id="element-8" />
      <Timeline title="Product Roadmap" subtitle="We're building AI that evolves with your business. Starting with core eCommerce integrations today, we're training our AI to recognize patterns, predict trends, and automate insights across your entire tech stack. Every feature we ship makes your data work harder for you." items={[{
      id: '1',
      status: 'live',
      title: 'Core Platform Launch',
      description: 'Our foundational platform with key integrations.',
      date: 'Q4 2025'
    }, {
      id: '2',
      status: 'development',
      title: 'Integration Hub Expansion',
      description: 'Community-voted app integrations.',
      date: 'Q4 2025'
    }, {
      id: '3',
      status: 'planned',
      title: 'Automated Reporting',
      description: 'Set-and-forget reports that surface insights.',
      date: 'Q1 2026'
    }, {
      id: '4',
      status: 'planned',
      title: 'Audit Sub-Agents',
      description: 'Specialized AI agents for Email, Subscriptions, Loyalty & Support optimization',
      date: 'Q1 2026'
    }, {
      id: '5',
      status: 'planned',
      title: 'Pattern Recognition',
      description: 'AI that learns your business rhythms and spots opportunities.',
      date: 'Q2 2026'
    }, {
      id: '6',
      status: 'future',
      title: 'Predictive Intelligence',
      description: 'Forecasting and trend prediction across your operation.',
      date: 'Q3 2026'
    }]} data-id="element-9" />
      <WaitlistForm data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}